import http from "@/axiosConfig";
import toast from "@/global/ToastConfig";

const settingRoute = {
    SAVE_COMPANY_SETTING: "dashboard/core/companySetting/save",
    GET_COMPARISON_SETTING: "dashboard/core/companySetting/find/comparison",
    GET_CUMULATIVE_DISCOUNTS_SETTING: "dashboard/core/companySetting/find/cumulative-discount",
}
export default {
    saveCompanySetting(setting) {
        return new Promise(resolve => {
            let code = -1;
            http.post(settingRoute.SAVE_COMPANY_SETTING, setting)
                .then(({data}) => {
                    code = data.code;
                    if (code > 0) {
                        toast.ok("Se han guardado correctamente los cambios");
                        return;
                    }
                    toast.error("Error al guardar la configuración");
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(code));
        });
    },
    findComparisonSettingByCompany(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(settingRoute.GET_COMPARISON_SETTING, {params: objParams})
                .then(({data}) => {
                    if (data.code < 0) {
                        toast.error(data.message)
                        newData=data;
                        return;
                    }
                    newData =data;
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },
    findCumulativeDiscountByCompany(objParams) {
        return new Promise(resolve => {
            let newData = {};
            http.get(settingRoute.GET_CUMULATIVE_DISCOUNTS_SETTING, {params: objParams})
                .then(({data}) => {
                    if (data.code < 0) {
                        toast.error(data.message)
                        newData=data;
                        return;
                    }
                    newData =data;
                })
                .catch(() => toast.error("No se pudo realizar la conexión con el servidor"))
                .finally(() => resolve(newData));
        });
    },

}